/*eslint-disable*/
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { createPopper } from "@popperjs/core";
import Swal from "sweetalert2";
import BASE_URL from "components/BaseUrl/apiConfig";
// components

import PagesDropdown from "components/Dropdowns/PagesDropdown.js";
import ExpenseDropdown from "components/Dropdowns/ExpenseDropdown";
import QuantityTrackingDropdown from "components/Dropdowns/QuantityTrackingDropdown";
import DocumentDropdown from "components/Dropdowns/DocumentDropdown";
import ExpenseChatbot from "components/Chatbot/ExpenseChatbot";

export default function Navbar(props) {
  const history = useHistory();
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };
  //Check localstorage null or not
  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  const sendReportEmail = async () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const groupId = userData.groupId;
    try {
      // Fetch the email addresses associated with the groupId
      const emailResponse = await fetch(
        `${BASE_URL}/api/Expense/GetEmailAddresses?groupId=${groupId}`
      );
      const emailData = await emailResponse.json();

      // Send the report to the fetched email addresses
      const encodedEmails = encodeURIComponent(emailData.msg);
      const reportResponse = await fetch(
        `${BASE_URL}/api/Expense/GetMessagesReport?groupId=${groupId}&emails=${encodedEmails}`,
        {
          method: "GET", // No body needed for GET
        }
      );

      if (reportResponse.ok) {
        Swal.fire({
          title: "Success!",
          text: "Messages report has been sent successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "Failed to send messages report.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error sending report:", error);
      Swal.fire({
        title: "Error!",
        text: "An error occurred while sending the report.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleOpenChatbot = () => {
    setNavbarOpen(false);
    window.dispatchEvent(new CustomEvent("openExpenseChatbot"));
  };

  // Retrieve user data from local storage
  const storedUserData = localStorage.getItem("userData");
  let userName = "";
  let userTypeId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);

    userName = userData.userName;
    userTypeId = userData.userTypeId;
  }

  const [navbarOpen, setNavbarOpen] = React.useState(false);
  return (
    <>
      <nav
        className="navbar navbar-expand-lg bg-white navbar-light sticky-top py-lg-0 px-lg-5 mb-3 shadow"
        data-wow-delay="0.1s"
      >
        {/* Logo + Toggle Row */}
        <div className="flex items-center justify-between w-full lg:w-auto px-4 lg:px-0">
          <Link to="/dashboard" className="navbar-brand">
            <img
              src={require("assets/img/essentials_small.png")}
              alt="Logo not found"
              style={{ width: "200px" }}
            />
          </Link>

          <button
            className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
            type="button"
            onClick={() => setNavbarOpen(!navbarOpen)}
          >
            <i className={navbarOpen ? "fas fa-times" : "fas fa-bars"}></i>
          </button>
        </div>

        {/* Navbar Links */}
        <div
          className={
            "w-full lg:flex lg:flex-grow items-center bg-white lg:bg-opacity-0 lg:shadow-none" +
            (navbarOpen ? " block" : " hidden")
          }
          id="example-navbar-warning"
        >
          <ul className="flex flex-col lg:flex-row list-none lg:ml-auto divide-y divide-gray-100 lg:divide-y-0">

            <li className="flex items-center">
              <Link
                to="/dashboard"
                onClick={() => setNavbarOpen(false)}
                className="custnav lg:text-black-800 lg:hover:text-blue-200 text-blueGray-700 px-4 py-3 lg:py-2 flex items-center text-base font-bold w-full"
              >
                Dashboard
              </Link>
            </li>

            <li className="flex items-center">
              <DocumentDropdown />
            </li>

            <li className="flex items-center">
              <ExpenseDropdown />
            </li>

            <li className="flex items-center">
              <Link
                to="/notes"
                onClick={() => setNavbarOpen(false)}
                className="custnav lg:text-black-800 lg:hover:text-blue-200 text-blueGray-700 px-4 py-3 lg:py-2 flex items-center text-base font-bold w-full"
              >
                Notes
              </Link>
            </li>

            <li className="flex items-center">
              <QuantityTrackingDropdown />
            </li>

            {/* Marketing Dropdown */}
            <li className="flex items-center relative">
              <div
                className="custnav lg:text-black-800 lg:hover:text-blue-200 text-blueGray-700 px-4 py-3 lg:py-2 flex items-center text-base font-bold cursor-pointer w-full"
                ref={btnDropdownRef}
                // Desktop: hover
                onMouseOver={(e) => { if (window.innerWidth >= 1024) { e.preventDefault(); openDropdownPopover(); } }}
                onMouseLeave={(e) => { if (window.innerWidth >= 1024) { e.preventDefault(); closeDropdownPopover(); } }}
                // Mobile: tap to toggle
                onClick={() => { if (window.innerWidth < 1024) { dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover(); } }}
              >
                Marketing
                <i className="fa fa-angle-down" aria-hidden="true" style={{ margin: "5px" }}></i>
              </div>

              <div
                ref={popoverDropdownRef}
                className={
                  (dropdownPopoverShow ? "block " : "hidden ") +
                  "lg:absolute lg:top-full left-0 bg-white text-base z-50 py-2 list-none text-left rounded shadow-lg min-w-48 w-full lg:w-auto"
                }
              >
                <Link
                  to="/marketingDashboard"
                  onClick={() => setNavbarOpen(false)}
                  className="custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
                >
                  Dashboard
                </Link>
                <Link
                  to="/emailChecker"
                  onClick={() => setNavbarOpen(false)}
                  className="custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
                >
                  Email Verifier
                </Link>
                <Link
                  to="/messageLogs"
                  onClick={() => setNavbarOpen(false)}
                  className="custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
                >
                  Messages
                </Link>
                <Link
                  to="/emailServerSettings"
                  onClick={() => setNavbarOpen(false)}
                  className="custnav text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
                >
                  Email Sender Settings
                </Link>
              </div>
            </li>

            {userTypeId != 3 ? (
              <li className="flex items-center">
                <Link
                  to="/getAllSubUsers"
                  onClick={() => setNavbarOpen(false)}
                  className="custnav lg:text-black-800 lg:hover:text-blue-200 text-blueGray-700 px-4 py-3 lg:py-2 flex items-center text-base font-bold w-full"
                >
                  Users
                </Link>
              </li>
            ) : null}

            {/* ── AI Assistant ── */}
            <li className="flex items-center px-3 py-2 lg:py-0">
              <button
                onClick={handleOpenChatbot}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "6px 13px",
                  background: "#eff6ff",
                  border: "1px solid #dbeafe",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontFamily: "inherit",
                  fontSize: "13.5px",
                  fontWeight: 600,
                  color: "#2563eb",
                  whiteSpace: "nowrap",
                  transition: "background 0.12s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#dbeafe")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "#eff6ff")}
              >
                <svg width="20" height="14" viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <ellipse cx="8" cy="35" rx="8" ry="12" fill="#2563eb" />
                  <ellipse cx="92" cy="35" rx="8" ry="12" fill="#2563eb" />
                  <rect x="14" y="5" width="72" height="60" rx="10" fill="#2563eb" />
                  <ellipse cx="36" cy="30" rx="6" ry="8" fill="white" />
                  <ellipse cx="64" cy="30" rx="6" ry="8" fill="white" />
                  <rect x="35" y="46" width="30" height="10" rx="3" fill="white" />
                  <rect x="42" y="49" width="16" height="4" rx="1" fill="#2563eb" />
                </svg>
                AI Help
              </button>
            </li>

            <li className="flex items-center">
              <PagesDropdown />
            </li>

          </ul>
        </div>
      </nav>
      <ExpenseChatbot />
    </>
  );
}
